export default __webpack_public_path__ + "static/media/simTransfer-3.fb387678.png";